module.exports = __webpack_public_path__ + "img/qrcode_for_gh_9183a2f83e7b_1280(3).8732366d.jpg";